export enum ModalSizes {
    small = '400px',
    default = '600px',
    large = 'min(800px, calc(100vw - 16px))',
    timeslots = 'min(960px, calc(100vw - 16px))',
}
